<template>
    <div @click="toggleShowCustomerServiceAI" class="ai-mini-popup">
        <img class="ai-image-popup" :src="headsetImg" />
    </div>
    <div class="ai-consult-chat-body" v-if="this.showCustomerServiceAI">
        <div class="ai-consult-title">
            <span>
                カスタマーサポート
            </span>
            <span class="close-button" @click="toggleShowCustomerServiceAI">
                -
            </span>
        </div>

        <div class="overflow-box">
            <div class="ai-popup-chat-body">
              <div
                v-for="dataChat in aiStore.state.chatData"
              >
                <div
                  :class="
                    dataChat.role === 'user'
                      ? 'ai-popup-chat'
                      : 'ai-popup-chat ai-box'
                  "
                  v-if="dataChat.content"
                >
                  <img
                    v-if="dataChat.role == 'user'"
                    class="profile-image"
                    :src="userProfile"
                  />
                  <img v-else class="profile-image" :src="aiProfile" />
                  <span v-html="dataChat.content"></span>
                </div>
              </div>
            </div>
          </div>


        <div class="ai-popup-chatbox-body">
            <form @submit="(e) => sendChatAi(e)" class="ai-popup-chatbox">
              <textarea
                v-on:keyup.enter="(e) => sendChatAi(e)"
                v-model="chatData"
                placeholder="何か質問する..."
              >
              </textarea>
              <img @click="sendChatAi" class="send-image" :src="sendImg" />
            </form>
        </div>
    </div>
</template>

<script>
import headsetImg from '../assets/headset.png'
import sendImg from '../assets/send-chat.png';
import userProfile from '../assets/user-profile.png';
import aiProfile from '../assets/ai-profile.png';
import { aiStore } from '../store/ai-store';
import backendApi from '../apis/backend-api';

export default {

  name: "AIPopupChat",
  data() {
    return {
        headsetImg,
        sendImg,
        showCustomerServiceAI: false,
        aiStore,
        chatData: "",
        aiProfile,
        userProfile,
    };
  },
  methods: {
    toggleShowCustomerServiceAI() {
        this.showCustomerServiceAI = !this.showCustomerServiceAI;
    },
    sendChatAi(e) {
      if (e.keyCode == 13 && e.shiftKey) {
        return;
      }
      if (e) {
        e.preventDefault();
      }
      const sendedChat = {
        content: this.chatData,
        type: 'free_text',
        role: 'user',
      };
      if (this.chatData !== '') {
        aiStore.commit('sendChat', sendedChat);
      }
      backendApi.sendCustomerAI(this.chatData);
      this.chatData = '';
    },
  },
};
</script>

<style scoped lang="scss">
.ai-mini-popup {
    position: fixed;
    background-color: #2A7FFF;
    bottom: 16px;
    right: 16px;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 100000;

    .ai-image-popup {
        width: 14px;
        height: 20px;
    }
}

.ai-consult-chat-body {
    display: flex;
    flex-direction: column;
    position: fixed;
    background-color: white;
    bottom: 69px;
    width: 478px;
    height: 70dvh;
    max-height: 677px;
    right: 16px;
    z-index: 100000;
    padding: 12px 16px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    
}

.ai-consult-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 30px;
    
        span {
            font-size: 20px;
            font-weight: 700;
        }

        .close-button {
            width: 18px;
            height: 18px;
            border: 1px solid black;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 3px;

            &:hover {
                cursor: pointer;
            }
        }
}

.ai-popup-chatbox-body {
  position: absolute;
  bottom: 0px;
  width: calc(100% - 32px);
  .ai-popup-chatbox {
    textarea {
      min-height: 64px;
      padding: 16px 48px 16px 20px;
      width: 100%;
      border: 1px solid #e0e0e0;
      font-size: 12px;
      resize: none;
      field-sizing: content;
      overflow: none;
    }

    .send-image {
      position: absolute;
      transform: translateY(-50%);
      top: 40%;
      right: 20px;
    }
  }
  button {
    width: 100%;
    height: 40px;
    background-color: #95c41c;
    border: none;
    color: white;
    border-radius: 8px;
  }
}

.overflow-box {
  height: 427px;
  overflow-y: auto;
  width: 442px;
  height: calc(70dvh - 144px);
  max-height: 548px;
}

.ai-popup-chat-body {
  margin-top: 38px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  .ai-popup-chat {
    padding: 6px;
    display: flex;
    gap: 16px;
  }

  .profile-image {
    width: 36px;
    height: 36px;
  }

  .ai-box {
    background-color: #fff8e6;
    border-radius: 8px;
  }

  span {
    width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap;
    font-size: 16px;
    text-align: left;
  }
}
</style>
